module.exports = __webpack_public_path__ + "img/25.2c78d033.jpg";